import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingBookedOverlay } from '../../components/NewbuildingBookedOverlay';
import { selectIsBookedFromDeveloper } from '../../selectors/newbuildingBookedFromDeveloper';

export const NewbuildingBookedOverlayContainer = () => {
  const isBooked = useSelector(selectIsBookedFromDeveloper);

  if (!isBooked) {
    return null;
  }

  return <NewbuildingBookedOverlay />;
};
